import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { setEditing, updateTasks, deleteTasks } from 'bundles/apex/deals/show/store/planner_bulk_actions/actions';

import Button from 'shared/button';
import Dropdown from 'components/dropdown';
import DateChangeModal from './date_change_modal';
import DeleteModal from './delete_modal';
import MarkCompleteModal from './mark_complete_modal';
import ReassignModal from './reassign_modal';
import { showSnackbar } from 'components/ui/snackbar/helper';

export function PlannerBulkEdit({ editing, selection, setEditing, updateTasks, deleteTasks }) {
  const [showReassignModal, setShowReassignModal] = useState(false);
  const [showMarkCompleteModal, setShowMarkCompleteModal] = useState(false);
  const [showDateChangeModal, setShowDateChangeModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const activateSnackbar = (text) => {
    showSnackbar({ text, variant: 'success' });
  };

  const handleDelete = async (text) => {
    await deleteTasks();
    activateSnackbar(text);
  };

  const handleUpdate = async (changes, text) => {
    const response = await updateTasks(changes);
    if (!response.errors) {
      activateSnackbar(text);
    }

    return response;
  };

  if (!editing) {
    return (
      <Button.Primary label="Bulk Edit" name="edit-button" onClick={() => setEditing(true)}/>
    );
  }

  return (
    <div className="d-flex gap-2">
      <Button.Cancel name="cancel-button" onClick={() => setEditing(false)}/>
      <Dropdown
        align="start"
        disabled={Object.keys(selection).length === 0}
        label="Bulk Actions"
        name="actions-button"
        variant="primary"
      >
        <Dropdown.Item label="Reassign" onClick={() => setShowReassignModal(true)} />
        <Dropdown.Item label="Move Due Date" onClick={() => setShowDateChangeModal(true)} />
        <Dropdown.Item label="Mark as Complete" onClick={() => setShowMarkCompleteModal(true)} />
        <Dropdown.Item label="Delete" onClick={() => setShowDeleteModal(true)} />
      </Dropdown>

      <ReassignModal
        show={showReassignModal}
        onClose={() => setShowReassignModal(false)}
        onUpdate={handleUpdate}
      />
      <MarkCompleteModal
        show={showMarkCompleteModal}
        onClose={() => setShowMarkCompleteModal(false)}
        onUpdate={handleUpdate}
      />
      <DateChangeModal
        show={showDateChangeModal}
        onClose={() => setShowDateChangeModal(false)}
        onUpdate={handleUpdate}
      />
      <DeleteModal
        show={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onDelete={handleDelete}
      />
    </div>
  );
}

PlannerBulkEdit.propTypes = {
  deleteTasks: PropTypes.func.isRequired,
  editing: PropTypes.bool.isRequired,
  selection: PropTypes.object.isRequired,
  setEditing: PropTypes.func.isRequired,
  updateTasks: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  editing: state.plannerBulkActions.editing,
  selection: state.plannerBulkActions.selection,
});

const mapDispatchToProps = {
  setEditing,
  updateTasks,
  deleteTasks
};

export default connect(mapStateToProps, mapDispatchToProps)(PlannerBulkEdit);
